const ShimmerUI = () => {
  return (
    <div className="shimmer-container">
      <div className="title-container"></div>
      <div className="filter-containers"></div>
      <div className="card-containers">
        <div className="cards">
          <div className="img-container"></div>
          <div className="detail-container">
            <div className="data-section"></div>
            <div className="data-section"></div>
            <div className="mini-section"></div>
          </div>
        </div>
        <div className="cards">
          <div className="img-container"></div>
          <div className="detail-container">
            <div className="data-section"></div>
            <div className="data-section"></div>
            <div className="mini-section"></div>
          </div>
        </div>
        <div className="cards">
          <div className="img-container"></div>
          <div className="detail-container">
            <div className="data-section"></div>
            <div className="data-section"></div>
            <div className="mini-section"></div>
          </div>
        </div>
        <div className="cards">
          <div className="img-container"></div>
          <div className="detail-container">
            <div className="data-section"></div>
            <div className="data-section"></div>
            <div className="mini-section"></div>
          </div>
        </div>
        <div className="cards">
          <div className="img-container"></div>
          <div className="detail-container">
            <div className="data-section"></div>
            <div className="data-section"></div>
            <div className="mini-section"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShimmerUI;
